import React from 'react';
import PropTypes from 'prop-types';

const CDModule = (props) => {
  let progressBarStyle = {
    fontSize: '0.7rem',
    paddingTop: 1,
  };
  if (props.progressPercent > 0) {
    progressBarStyle.width = `${props.progressPercent}%`;
    if (props.progressBarColor) progressBarStyle.backgroundColor = props.progressBarColor;
  } else {
    progressBarStyle = {
      ...progressBarStyle,
      width: '10px',
      background: 'none',
      color: '#000000',
      paddingLeft: 5,
    };
  }

  return (
    <div style={{ padding: 5, margin: '5px 0' }}>
      <p style={{ fontSize: '1.1rem', marginBottom: 0 }}>{props.title}</p>
      <div className="progress" style={props.progressBarBgColor ? { backgroundColor: props.progressBarBgColor } : null}>
        <div className="progress-bar" style={progressBarStyle}>
          {props.progressPercent}%
        </div>
      </div>
    </div>
  );
};

CDModule.propTypes = {
  title: PropTypes.string.isRequired,
  progressPercent: PropTypes.number.isRequired,
  progressBarBgColor: PropTypes.string,
  progressBarColor: PropTypes.string,
};

CDModule.defaultProps = {
  progressBarBgColor: null,
  progressBarColor: null,
};

export default CDModule;



// WEBPACK FOOTER //
// ./src/components/CDModule.jsx